import lazyLoading from './lazyLoading'

export default {
  name: 'PasswordReset',
  path: '/password_reset',
  hidden: true,
  meta: {
    auth: false,
    link: 'password_reset/'
  },
  component: lazyLoading('auth/passwordReset', true),
  props: route => ({passwordResetToken: route.query.passwordResetToken})
}
